/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ApiToken } from './apiToken';


export interface ApiTokenResponse { 
    token: string;
    apiToken: ApiToken;
}

